module.exports = __webpack_public_path__ + "img/P150T_weapon_91.f1737c99.png";